// extracted by mini-css-extract-plugin
export default {"modal":"ValidationModal__modal___EnaPA","EditButton":"ValidationModal__EditButton___lMqSK"};